<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let sectors = [];
  let loading = true;
  let error = null;

  let showCreateModal = false;
  let showEditModal = false;
  let currentSector = null;
  let newSector = {
    value_str: '',
    value_num: null,
    color: '#FFFFFF',
    text_color: '#000000',
    sector_type: 'stars',
    prize_id: null,
    weight: 1,
    is_active: true,
  };
  let editSectorData = {};

  // Должны соответствовать enum/типам в бэкенде
  const sectorTypes = ['stars', 'spins', 'unique_prize', 'empty'];

  // Unified form data and submit handler based on mode
  $: formData = showCreateModal ? newSector : editSectorData;
  $: submitHandler = showCreateModal ? handleCreateSector : handleUpdateSector;

  onMount(() => {
    loadSectors();
  });

  async function loadSectors() {
    loading = true;
    error = null;
    const result = await fetchAdminAPI('/roulette-sectors', 'GET', null, authData);
    if (result.success) {
      sectors = result.data || [];
    } else {
      error = result.message;
      sectors = [];
    }
    loading = false;
  }

  function openCreateModal() {
    newSector = {
      value_str: '',
      value_num: null,
      color: '#FFFFFF',
      text_color: '#000000',
      sector_type: 'stars',
      prize_id: null,
      weight: 1,
      is_active: true,
    };
    showCreateModal = true;
  }

  async function handleCreateSector() {
    const payload = { ...newSector };
    if (payload.value_str === "") payload.value_str = " ";
    payload.value_num = payload.value_num === '' || payload.value_num === null ? null : Number(payload.value_num);
    payload.prize_id = payload.prize_id === "" ? null : payload.prize_id;
    payload.weight = Number(payload.weight) > 0 ? Number(payload.weight) : 1;

    const result = await fetchAdminAPI('/roulette-sectors', 'POST', payload, authData);
    if (result.success) {
      showCreateModal = false;
      loadSectors();
    } else {
      alert(`Ошибка создания сектора: ${result.message}`);
    }
  }

  function openEditModal(sector) {
    currentSector = sector;
    editSectorData = {
      value_str: sector.ValueStr,
      value_num: sector.ValueNum,
      color: sector.Color,
      text_color: sector.TextColor,
      sector_type: sector.SectorType,
      prize_id: sector.PrizeID,
      weight: sector.Weight,
      is_active: sector.IsActive,
    };
    showEditModal = true;
  }

  async function handleUpdateSector() {
    if (!currentSector) return;
    const payload = { ...editSectorData };
    payload.value_num = payload.value_num === '' || payload.value_num === null ? null : Number(payload.value_num);
    payload.prize_id = payload.prize_id === "" ? null : payload.prize_id;
    payload.weight = Number(payload.weight) > 0 ? Number(payload.weight) : 1;

    const result = await fetchAdminAPI(`/roulette-sectors/${currentSector.ID}`, 'PATCH', payload, authData);
    if (result.success) {
      showEditModal = false;
      currentSector = null;
      loadSectors();
    } else {
      alert(`Ошибка обновления сектора: ${result.message}`);
    }
  }

  async function handleDeleteSector(sectorId) {
    if (!confirm(`Уверены, что хотите удалить сектор ID: ${sectorId}? Это действие необратимо и возможно только если нет связанных логов.`)) return;
    const result = await fetchAdminAPI(`/roulette-sectors/${sectorId}`, 'DELETE', null, authData);
    if (result.success) {
      loadSectors();
    } else {
      alert(`Ошибка удаления сектора: ${result.message}`);
    }
  }
</script>

<div class="roulette-sectors-admin-section">
  <div class="admin-section-header">
    <h2>Управление секторами рулетки</h2>
    <div class="actions">
      <button class="admin-create" on:click={openCreateModal}>
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: text-bottom;">
          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
        </svg>
        Создать сектор
      </button>
    </div>
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка секторов...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if sectors.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">Секторов пока нет. Нажмите "Создать сектор", чтобы добавить первый.</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Текст</th>
              <th>Значение</th>
              <th>Тип</th>
              <th>Prize ID</th>
              <th>Вес</th>
              <th>Цвета</th>
              <th>Активен</th>
              <th style="text-align: right;">Действия</th>
            </tr>
          </thead>
          <tbody>
            {#each sectors as sector (sector.ID)}
              <tr>
                <td>{sector.ID}</td>
                <td>{sector.ValueStr}</td>
                <td>{sector.ValueNum === null ? '–' : sector.ValueNum}</td>
                <td>{sector.SectorType}</td>
                <td>{sector.PrizeID || '–'}</td>
                <td>{sector.Weight}</td>
                <td>
                  <span class="color-preview" style="background-color:{sector.Color}; color:{sector.TextColor};">
                    Aa
                  </span>
                  <small>({sector.Color}, {sector.TextColor})</small>
                </td>
                <td>
                  <span class:status-active={sector.IsActive} class:status-inactive={!sector.IsActive}>
                    {sector.IsActive ? 'Да' : 'Нет'}
                  </span>
                </td>
                <td class="admin-actions" style="text-align: right;">
                  <button class="admin-action-button admin-edit" on:click={() => openEditModal(sector)}>Редакт.</button>
                  <button class="admin-action-button admin-delete" on:click={() => handleDeleteSector(sector.ID)}>Удалить</button>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/if}
  </div>
</div>

<!-- Create/Edit Sector Modals -->
{#if showCreateModal || showEditModal}
  <div class="modal" on:click|self={() => { showCreateModal = false; showEditModal = false; currentSector = null;}} role="dialog" aria-modal="true">
    <div class="modal-content">
      <h3>{showCreateModal ? 'Создать новый сектор' : `Редактировать сектор ID: ${currentSector?.ID}`}</h3>
      <form on:submit|preventDefault={submitHandler} class="admin-form">
        <label>Текст на секторе (ValueStr):</label>
        <input type="text" bind:value={formData.value_str} required>

        <label>Числовое значение (ValueNum, необязательно):</label>
        <input type="number" bind:value={formData.value_num}>

        <label>Тип сектора (SectorType):</label>
        <select bind:value={formData.sector_type}>
          {#each sectorTypes as type (type)}
            <option value={type}>{type}</option>
          {/each}
        </select>

        <label>ID Приза (PrizeID, для SectorType='unique_prize', необязательно, должен быть уникальным):</label>
        <input type="text" bind:value={formData.prize_id}>
        
        <label>Вес (Weight, целое > 0):</label>
        <input type="number" bind:value={formData.weight} min="1" required>
        
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
            <div>
                <label>Цвет фона (Color):</label>
                <div style="display:flex; align-items:center; gap: 8px;">
                    <input type="color" bind:value={formData.color} style="padding:0; height: 38px; width: 50px; border-radius:6px;">
                    <input type="text" bind:value={formData.color} placeholder="#RRGGBB" style="flex:1">
                </div>
            </div>
            <div>
                <label>Цвет текста (TextColor):</label>
                 <div style="display:flex; align-items:center; gap: 8px;">
                    <input type="color" bind:value={formData.text_color} style="padding:0; height: 38px; width: 50px; border-radius:6px;">
                    <input type="text" bind:value={formData.text_color} placeholder="#RRGGBB" style="flex:1">
                </div>
            </div>
        </div>

        <label for="sector-active" style="margin-top: 15px; display:flex; align-items:center;">
          <input id="sector-active" type="checkbox" bind:checked={formData.is_active} style="width: auto; height: auto;">
          <span style="margin-left: 5px;">Активен</span>
        </label>
        
        <div class="form-actions">
          <button type="button" on:click={() => { showCreateModal = false; showEditModal = false; currentSector = null; }} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">{showCreateModal ? 'Создать' : 'Сохранить'}</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  .table-responsive-wrapper { overflow-x: auto; }
  .color-preview {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid rgba(255,255,255,0.2);
    font-weight: bold;
    margin-right: 5px;
    min-width: 30px;
    text-align: center;
    font-size: 0.85em;
    line-height: 1;
  }
  .color-preview + small {
    font-size: 0.8em;
    color: #9DB2BF;
    opacity: 0.7;
  }
  .status-active, .status-inactive { /* Повторение */
    padding: 4px 10px; border-radius: 16px; font-size: 0.8em; font-weight: 500;
    display: inline-block; text-transform: uppercase; letter-spacing: 0.5px;
  }
  .status-active {
    color: #6EE7B7; background-color: rgba(52, 211, 153, 0.15); border: 1px solid rgba(52, 211, 153, 0.3);
  }
  .status-inactive {
    color: #9CA3AF; background-color: rgba(156, 163, 175, 0.1); border: 1px solid rgba(156, 163, 175, 0.2);
  }
  /* Инпут цвета в модалке */
  :global(.modal-content .admin-form input[type="color"]) {
    border-radius: 6px; /* Убираем стандартные рамки */
    border: 2px solid rgba(135, 195, 255, 0.3); /* Добавляем свою рамку */
    cursor: pointer;
    min-height: 38px; /* Для консистентности высоты */
  }
  :global(.modal-content .admin-form input[type="color"]:hover) {
    border-color: rgba(135, 195, 255, 0.5);
  }
</style>